<template>
  <Hero :title="data?.header.title" :subtitle="data?.header.subtitle" :images="data?.header.images"/>
  <main class="main maxw--waist mt-2">
    <section v-for="section in data?.sections" :key="section.id" class="mb-2">
      <h2 class="mb-1" v-if="section.faqs.length > 0"> {{ section.heading }}</h2>
      
      <HeadlessDisclosure v-for="faq in section.faqs" :key="faq.id" as="div" class="card mb-1" v-auto-animate="{ duration: 215 }" v-slot="{ open }">
        <HeadlessDisclosureButton as="div" class="faq__header" :class="{ active: open }">
          <h5>{{ faq.question }}</h5>
          <div class="faq__plus" :class="{ active: open }"></div>
        </HeadlessDisclosureButton>
        <HeadlessDisclosurePanel>
          <div v-html="$md.render(faq.answer || '')" class="pt-1"></div>
        </HeadlessDisclosurePanel>
      </HeadlessDisclosure>
    </section>
  </main>
</template>

<script lang="ts" setup>
import FAQPage from '~/typings/pages/faq_page';

useHead({
  title: 'FAQ'
});

const { findOne } = useStrapi();

const { data } = await useAsyncData(
  'faqpage',
  () => findOne<FAQPage>('faq-page', { populate: ['header', 'header.images', 'sections', 'sections.faqs'] }),
  {
    transform: flattenStrapiObject
  }
)
</script>

<style lang="scss">
.faq__header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  h5 {
    transition: color 215ms ease-in-out;
  }

  &:hover, &.active {
    h5 {
      color: $primary;
    }
  }
}

.faq__plus {
  height: 1.1rem;
  width: 1.1rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1rem;

  &::after, &::before {
    content: '';
    width: 4px;
    height: 100%;
    position: absolute;
    top: 0;
    background: $primary;
    border-radius: 2px;
    transition: all 215ms cubic-bezier(.23,.64,.59,.99);
  }

  &::after {
    transform: rotate(90deg);
  }

  &.active::before {
    transform: rotate(90deg);
  }
}
</style>
